import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global fetch interceptor: add Authorization header for OUR API calls only
// and strip credentials:'include' to avoid CORS issues with wildcard origin
// Matches both absolute (REACT_APP_BACKEND_URL/api/...) and relative (/api/...) URLs
const _origFetch = window.fetch;
const _backendUrl = process.env.REACT_APP_BACKEND_URL || '';
window.fetch = function(url, opts = {}) {
  const isOurApi = typeof url === 'string' && (
    url.startsWith('/api/') ||
    (_backendUrl && url.startsWith(_backendUrl + '/api/'))
  );
  if (isOurApi) {
    const token = localStorage.getItem('swell_session_token');
    opts = { ...opts };
    if (token) {
      opts.headers = { ...opts.headers, Authorization: `Bearer ${token}` };
    }
    delete opts.credentials;
  }
  return _origFetch.call(this, url, opts);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
